/* eslint-disable no-restricted-imports */
import { DirectCampaignUI } from '../../../../../../data-layer/direct/types';
import { DirectProcessText } from '../../../types';

const stateTextMap = {
    DRAFT: DirectProcessText.START,
    OFF: DirectProcessText.SUSPEND,
    ON: DirectProcessText.SUSPEND,
    SUSPENDED: DirectProcessText.RESUME,
    ARCHIVED: null,
    UNKNOWN: null,
    CONVERTED: null,
    ENDED: null,
};

export const getStatusButtonText = (company?: DirectCampaignUI) => {
    const { status, state } = company || {};

    if (status === 'DRAFT') {
        return stateTextMap.DRAFT;
    }

    if (!status || !state || status !== 'ACCEPTED') {
        return null;
    }

    return stateTextMap[state];
};
